import { z } from 'zod';
import { DeviceGenre } from '@/constants/device';
import { OrderDirection } from '@/constants/orderDirection';
import { ContractType } from '../../../-types/product';
import type { StoreProductsQuery } from './-types';
const OrderBy = {
  PRODUCT_NAME: 'PRODUCT_NAME'
} as const satisfies Record<string, StoreProductsQuery['orderBy']>;
export const SearchSchema = z.object({
  orderDirection: z.nativeEnum(OrderDirection).optional().default(OrderDirection.ASC),
  orderBy: z.nativeEnum(OrderBy).optional(),
  freeText: z.string().optional(),
  deviceGenreIn: z.array(z.nativeEnum(DeviceGenre)).optional(),
  contractMethodIn: z.array(z.nativeEnum(ContractType)).optional(),
  pageSize: z.number().int().positive().default(10),
  pageIndex: z.number().int().min(0).default(0),
  priceRangeMin: z.string().optional(),
  priceRangeMax: z.string().optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;